import { Helmet } from "react-helmet";
import { useEffect } from "react";
import Logo from "@/components/shared/Logo";
import ThemeToggle from "@/components/layout/ThemeToggle";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

// Import updated section components
import HowItWorksSection from "@/components/cayman/sections/HowItWorksSection";
import CountryHero from "@/components/country/CountryHero";
import Footer from "@/components/layout/Footer";
import NationalSentimentDashboard from "@/components/cayman/sections/NationalSentimentDashboard";
import FeaturedInsightsCarousel from "@/components/cayman/sections/FeaturedInsightsCarousel";
import SolutionActionSpotlight from "@/components/cayman/sections/SolutionActionSpotlight";
import JoinMovementSection from "@/components/cayman/sections/JoinMovementSection";
import ResourcesGrid from "@/components/cayman/sections/ResourcesGrid";
import UnderstandingCards from "@/components/cayman/sections/UnderstandingCards";

const CaymanEnhanced = () => {
  // Update page title
  useEffect(() => {
    document.title = "NationCard™ Cayman Islands — Enhanced Experience";
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <Helmet>
        <title>NationCard™ Cayman Islands — Enhanced Experience</title>
        <meta
          name="description"
          content="Experience the enhanced NationCard™ platform for the Cayman Islands - keeping democracy alive after election day."
        />
      </Helmet>

      {/* Header */}
      <header className="border-b border-gray-200 dark:border-gray-700 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm fixed top-0 left-0 right-0 z-50">
        <div className="container max-w-7xl mx-auto flex justify-between items-center px-4 py-3">
          <Logo
            onClick={() => window.scrollTo(0, 0)}
            className="h-10 cursor-pointer"
          />
          <div className="flex items-center gap-4">
            <ThemeToggle />
            <Button variant="outline" size="sm" asChild>
              <Link to="/cayman">Original Page</Link>
            </Button>
            <Button variant="outline" size="sm" asChild>
              <Link to="/cards/KY">Enter NationCard™</Link>
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section - Using CountryHero with showSelector set to false */}
      <div className="pt-16">
        <CountryHero
          countryName="Cayman Islands"
          backgroundImageUrl="/img/nationcard-hero1.png"
          backgroundImageAlt="Cayman Islands"
          showSelector={false}
        />
      </div>

      {/* National Sentiment Dashboard */}
      <NationalSentimentDashboard />

      {/* Understanding Cards Section - New section explaining Polls and Insight Cards */}
      <UnderstandingCards />

      {/* How It Works Section */}
      <HowItWorksSection />

      {/* Featured Insights Carousel */}
      <FeaturedInsightsCarousel />

      {/* Solution & Action Cards Spotlight - Updated as coming soon */}
      <SolutionActionSpotlight />

      {/* Join the Movement Section - Updated to remove signup form */}
      <JoinMovementSection />

      {/* Resources Grid */}
      <ResourcesGrid />

      {/* Footer - Using original Footer from frontpage */}
      <Footer />
    </div>
  );
};

export default CaymanEnhanced;
